import React, { useCallback, useMemo, useState } from 'react';
import { DailyHours, HoursRange } from '@leverege/operating-hours';
import { Button, DateTimePicker, Pane, Selector, Toast } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { format, parse } from 'date-fns';
import CopyHoursWidget from "./CopyHoursWidget.js";
import { getEvenOddVariant, getTimeList } from "./Util.js";
import S from './WeeklyHoursEditor.css';
const {
  t,
  tIcon
} = I18N.ns('imagine.operatingHours.DailyHoursEditor');
const parseFormats = ['hh:mma', 'h:mma', 'HH:mm', 'HH:m', 'hh:ma', 'h:ma'];
export default function RangeEditor(props) {
  const {
    value,
    eventData,
    onChange: pOnChange,
    range,
    index,
    isEven,
    onDeleteRange,
    onAddRange,
    onCopyHours
  } = props;
  const [errorStart, setErrorStart] = useState(false);
  const [errorEnd, setErrorEnd] = useState(false);
  const start = HoursRange.getStart(range);
  const end = HoursRange.getEnd(range);
  const timeList = useMemo(() => {
    return getTimeList();
  }, []);
  const onTimeChange = useCallback(({
    data,
    value: val
  }) => {
    setErrorStart(false);
    setErrorEnd(false);
    let startDate;
    let endDate;
    if (data === 'setStart') {
      startDate = parse(val, 'hh:mma', new Date());
      endDate = parse(HoursRange.getEnd(range), 'hh:mma', new Date());
    } else {
      startDate = parse(HoursRange.getStart(range), 'hh:mma', new Date());
      endDate = parse(val, 'hh:mmd', new Date());
    }
    if (endDate <= startDate) {
      if (data === 'setStart') {
        Toast.error([t('errorTitle'), t('errorBody', {
          context: 'start'
        })]);
        setErrorStart(true);
      } else {
        Toast.error([t('errorTitle'), t('errorBody', {
          context: 'end'
        })]);
        setErrorEnd(true);
      }
    } else {
      const time = val;
      const nRange = HoursRange[data](range, time);
      const nValue = DailyHours.setRange(value, index, nRange);
      pOnChange({
        value: nValue,
        data: eventData
      });
    }
  }, [eventData, index, pOnChange, range, value]);
  if (index === 0) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: `${start}-${end}-${index}`
    }, /*#__PURE__*/React.createElement(Selector, {
      showFilter: true,
      "data-error": errorStart,
      eventData: "setStart",
      className: S.picker,
      onChange: onTimeChange,
      variant: getEvenOddVariant('operatingHoursDay', isEven, 'timeOnly'),
      toggleVariant: getEvenOddVariant('operatingHoursDay', isEven, 'timeOnly'),
      value: start,
      values: timeList
    }), /*#__PURE__*/React.createElement(Selector, {
      showFilter: true,
      "data-error": errorEnd,
      eventData: "setEnd",
      className: S.picker,
      onChange: onTimeChange,
      variant: getEvenOddVariant('operatingHoursDay', isEven, 'timeOnly'),
      toggleVariant: getEvenOddVariant('operatingHoursDay', isEven, 'timeOnly'),
      value: end,
      values: timeList
    }), /*#__PURE__*/React.createElement(Pane, {
      className: S.toolbar
    }, /*#__PURE__*/React.createElement(Button, {
      className: S.remove,
      variant: getEvenOddVariant('dailyHoursAction', isEven, 'linkNeutralNoPad'),
      icon: tIcon('deleteIcon', 'fa fa-fw fa-trash'),
      onClick: onDeleteRange,
      eventData: index
    }), /*#__PURE__*/React.createElement(Button, {
      className: S.add,
      onClick: onAddRange,
      icon: t('addIcon', 'fa fa-fw fa-plus'),
      variant: getEvenOddVariant('dailyHoursAction', isEven, 'linkNeutralNoPad')
    }), /*#__PURE__*/React.createElement(CopyHoursWidget, {
      isEven: isEven,
      className: S.copy,
      onChange: onCopyHours,
      eventData: eventData
    })));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement(Selector, {
    showFilter: true,
    "data-error": errorStart,
    eventData: "setStart",
    className: S.picker,
    onChange: onTimeChange,
    variant: getEvenOddVariant('operatingHoursDay', isEven, 'timeOnly'),
    toggleVariant: getEvenOddVariant('operatingHoursDay', isEven, 'timeOnly'),
    value: start,
    values: timeList
  }), /*#__PURE__*/React.createElement(Selector, {
    showFilter: true,
    "data-error": errorEnd,
    eventData: "setEnd",
    className: S.picker,
    onChange: onTimeChange,
    variant: getEvenOddVariant('operatingHoursDay', isEven, 'timeOnly'),
    toggleVariant: getEvenOddVariant('operatingHoursDay', isEven, 'timeOnly'),
    value: end,
    values: timeList
  }), /*#__PURE__*/React.createElement(Pane, {
    className: S.toolbar
  }, /*#__PURE__*/React.createElement(Button, {
    className: S.remove,
    variant: "linkNeutralNoPad",
    icon: tIcon('deleteIcon', 'fa fa-fw fa-trash'),
    onClick: onDeleteRange,
    eventData: index
  })));
}